/**
 * Icons Component
 */
/* tslint:disable:max-line-length */
// tslint:disable:jsx-self-close

import * as React from 'react';
import * as BEM from 'react-bem-helper';
import './styles.scss';

import {
  IconLicenseAllMedia,
  IconLicenseCaseStudy,
  IconLicenseIndustrial,
  IconLicensePodcast,
  IconLicenseRadio,
  IconLicenseShowReel,
  IconLicenseSocialMedia,
  IconLicenseTheatrical,
  IconLicenseTV,
  IconLicenseTVEditorial,
  IconLicenseTVWeb,
  IconLicenseWeb,
} from './license-icons';

import {
  IconPlayerNext,
  IconPlayerPause,
  IconPlayerPlay,
  IconPlayerPrevious,
} from './player-icons';

import {
  IconApple,
  IconBandCamp,
  IconFacebook,
  IconGoogle,
  IconInstagram,
  IconSoundCloud,
  IconSpotify,
  IconTwitter,
} from './social-icons';

export {
  IconApple,
  IconBandCamp,
  IconFacebook,
  IconGoogle,
  IconInstagram,
  IconLicenseAllMedia,
  IconLicenseCaseStudy,
  IconLicenseIndustrial,
  IconLicensePodcast,
  IconLicenseRadio,
  IconLicenseShowReel,
  IconLicenseSocialMedia,
  IconLicenseTheatrical,
  IconLicenseTV,
  IconLicenseTVEditorial,
  IconLicenseTVWeb,
  IconLicenseWeb,
  IconPlayerNext,
  IconPlayerPause,
  IconPlayerPlay,
  IconPlayerPrevious,
  IconSoundCloud,
  IconSpotify,
  IconTwitter,
};

function IconWrapper({ children, className, id, ...rest }) {
  const classes = new BEM('icon');

  return <div {...classes('', id, className) } {...rest}>{children}</div>;
}

export function LogoAMS({ className = '', ...props }) {
  return (
    <IconWrapper id="logo-ams" className={className} {...props}>
      <svg width="22" height="20" viewBox="0 0 22 20" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.674 17.768c-1.936.694-4.032-.23-4.853-2.16-1.825-4.3-1.825-4.3-3.716.08-.828 1.92-2.994 2.847-4.955 2.029-1.963-.818-2.953-3.089-2.065-5.024.888-1.936 3.003-2.572 4.933-2.023 3.978 1.132 3.978 1.132 1.654-1.902-1.204-1.574-2.363-3.253-.495-5.556 1.457-1.8 4.155-1.536 5.522-.052 1.56 1.697 1.122 3.751-.33 5.608-2.373 3.034-2.373 3.034 1.29 1.953 2.109-.62 4.247-.016 5.13 1.943.923 2.041-.12 4.388-2.115 5.104m2.456-7.176l-4.748-7.048c-2.236-3.433-6.586-3.35-8.827 0 0 0-3.304 5.01-4.702 7.048-2.912 4.244.145 8.41 3.67 8.408h10.892c3.573.002 6.684-4.216 3.715-8.408" fill="currentColor" fillRule="evenodd" />
      </svg>
    </IconWrapper>
  );
}

export function LogoBopper({ className = '', ...props }) {
  return (
    <IconWrapper id="logo-bopper" className={className} {...props}>
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.5 8H5V15H9.5C11.433 15 13 13.433 13 11.5C13 9.567 11.433 8 9.5 8Z" fill="currentColor"/>
        <path d="M18.5 8C16.567 8 15 9.567 15 11.5C15 13.433 16.567 15 18.5 15H23.5C25.433 15 27 13.433 27 11.5C27 9.567 25.433 8 23.5 8H18.5Z" fill="currentColor"/>
        <path d="M20 20.5C20 18.567 21.567 17 23.5 17C25.433 17 27 18.567 27 20.5C27 22.433 25.433 24 23.5 24C21.567 24 20 22.433 20 20.5Z" fill="currentColor"/>
        <path d="M14.5 17H5V24H14.5C16.433 24 18 22.433 18 20.5C18 18.567 16.433 17 14.5 17Z" fill="currentColor"/>
      </svg>
    </IconWrapper>
  );
}

export function LogoBopperWithName({ className = '', ...props }) {
  return (
    <IconWrapper id="logo-bopper-name" className={className} {...props}>
      <svg preserveAspectRatio="xMinYMid slice" height="32" width="100" viewBox="32 0 519 161" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M176.95 59.8031C180.386 57.4127 184.764 55.994 189.788 55.994C206.854 55.994 214.138 67.9514 214.138 83.9309C214.138 99.9104 206.854 111.977 189.788 111.977C184.779 111.977 180.411 110.566 176.98 108.139C175.872 107.356 174.134 108.087 174.134 109.445V110.977C174.134 111.529 173.687 111.977 173.134 111.977H161.003C160.451 111.977 160.003 111.529 160.003 110.977V43.0002C160.003 42.448 160.451 42.0002 161.003 42.0002H173.134C173.687 42.0002 174.134 42.448 174.134 43.0002V58.4932C174.134 59.8401 175.844 60.5723 176.95 59.8031ZM174.134 83.9309C174.134 95.1274 178.048 97.845 187.07 97.845C196.093 97.845 200.006 95.1274 200.006 83.9309C200.006 72.8431 196.093 70.1255 187.07 70.1255C178.048 70.1255 174.134 72.8431 174.134 83.9309Z" fill="#101015"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M272.04 83.9311C272.04 99.9106 262.583 111.977 244.973 111.977C227.363 111.977 217.905 99.9106 217.905 83.9311C217.905 67.9516 227.363 55.9942 244.973 55.9942C262.583 55.9942 272.04 67.9516 272.04 83.9311ZM232.037 83.9311C232.037 94.8015 235.407 97.8452 244.973 97.8452C254.539 97.8452 257.908 94.8015 257.908 83.9311C257.908 73.0607 254.539 70.1257 244.973 70.1257C235.407 70.1257 232.037 73.0607 232.037 83.9311Z" fill="#101015"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M305.788 55.9942C300.764 55.9942 296.385 57.4129 292.95 59.8033C291.844 60.5725 290.134 59.8403 290.134 58.4934V56.9942C290.134 56.4419 289.687 55.9942 289.134 55.9942H277.003C276.45 55.9942 276.003 56.4419 276.003 56.9942V124.999C276.003 125.551 276.45 125.999 277.003 125.999H289.134C289.687 125.999 290.134 125.551 290.134 124.999V109.445C290.134 108.088 291.872 107.356 292.98 108.139C296.411 110.566 300.779 111.977 305.788 111.977C322.854 111.977 330.137 99.9106 330.137 83.9311C330.137 67.9516 322.854 55.9942 305.788 55.9942ZM303.07 97.8452C294.048 97.8452 290.134 95.1276 290.134 83.9311C290.134 72.8433 294.048 70.1257 303.07 70.1257C312.092 70.1257 316.006 72.8433 316.006 83.9311C316.006 95.1276 312.092 97.8452 303.07 97.8452Z" fill="#101015"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M350.946 59.8033C354.382 57.4129 358.76 55.9942 363.784 55.9942C380.851 55.9942 388.134 67.9516 388.134 83.9311C388.134 99.9106 380.851 111.977 363.784 111.977C358.776 111.977 354.409 110.567 350.979 108.141C349.87 107.357 348.132 108.09 348.133 109.447L348.14 124.999C348.14 125.552 347.693 126 347.14 126H335.009C334.457 126 334.009 125.552 334.009 125L333.999 56.9943C333.999 56.442 334.447 55.9942 334.999 55.9942H347.131C347.683 55.9942 348.131 56.4419 348.131 56.9942V58.4934C348.131 59.8403 349.84 60.5725 350.946 59.8033ZM348.131 83.9311C348.131 95.1276 352.044 97.8452 361.066 97.8452C370.089 97.8452 374.002 95.1276 374.002 83.9311C374.002 72.8433 370.089 70.1257 361.066 70.1257C352.044 70.1257 348.131 72.8433 348.131 83.9311Z" fill="#101015"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M441.289 82.8441C441.289 67.6255 434.549 55.9942 416.939 55.9942C398.894 55.9942 392.154 68.4951 392.154 84.0398C392.154 94.258 395.742 111.977 420.852 111.977C424.855 111.977 428.858 111.977 436.817 110.196C437.271 110.095 437.593 109.69 437.593 109.225V97.3644C437.593 96.7208 436.992 96.2455 436.363 96.3808C429.552 97.8452 425.019 97.8452 421.939 97.8452C412.905 97.8452 409.054 95.4659 407.457 91.1581C407.124 90.2596 407.846 89.3663 408.804 89.3663H437.789C439.722 89.3663 441.289 87.7993 441.289 85.8663V82.8441ZM416.722 70.1257C422.846 70.1257 426.008 71.9209 426.861 76.8978C427.008 77.7551 426.309 78.4959 425.44 78.4959H408.071C407.177 78.4959 406.471 77.7141 406.665 76.8415C407.708 72.1527 410.849 70.1257 416.722 70.1257Z" fill="#101015"/>
        <path d="M480.002 55.9942C480.554 55.9942 481.002 56.4419 481.002 56.9942V69.1257C481.002 69.678 480.554 70.1257 480.002 70.1257H463.631C461.698 70.1257 460.131 71.6927 460.131 73.6257V110.977C460.131 111.529 459.683 111.977 459.131 111.977H446.999C446.447 111.977 445.999 111.529 445.999 110.977V69.9942C445.999 62.2622 452.267 55.9942 459.999 55.9942H480.002Z" fill="#101015"/>
        <path d="M61 49H42V77H61C68.732 77 75 70.732 75 63C75 55.268 68.732 49 61 49Z" fill="#101015"/>
        <path d="M96 49C88.268 49 82 55.268 82 63C82 70.732 88.268 77 96 77H115C122.732 77 129 70.732 129 63C129 55.268 122.732 49 115 49H96Z" fill="#101015"/>
        <path d="M100 98C100 90.268 106.268 84 114 84H115C122.732 84 129 90.268 129 98C129 105.732 122.732 112 115 112H114C106.268 112 100 105.732 100 98Z" fill="#101015"/>
        <path d="M79 84H42V112H79C86.732 112 93 105.732 93 98C93 90.268 86.732 84 79 84Z" fill="#101015"/>
      </svg>
    </IconWrapper>
  );
}

export function IconProject({ className = '', ...props }) {
  return (
    <IconWrapper id="project" className={className} {...props}>
      <svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
        <path d="M20.766 9.238C19.944 8.413 18.952 8 17.79 8c-1.163 0-2.156.413-2.978 1.238l-.811.814-.812-.814C12.366 8.413 11.374 8 10.211 8c-1.163 0-2.155.413-2.978 1.238C6.411 10.063 6 11.058 6 12.225c0 1.166.411 2.162 1.233 2.987l.812.814L14 22l5.955-5.974.811-.814c.823-.825 1.234-1.82 1.234-2.987s-.411-2.163-1.234-2.987z" stroke="currentColor" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </IconWrapper>
  );
}
export function IconProjectSelected({ className = '', ...props }) {
  return (
    <IconWrapper id="project-selected" className={className} {...props}>
      <svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
        <path d="M20.766 9.238C19.944 8.413 18.952 8 17.79 8c-1.163 0-2.156.413-2.978 1.238l-.811.814-.812-.814C12.366 8.413 11.374 8 10.211 8c-1.163 0-2.155.413-2.978 1.238C6.411 10.063 6 11.058 6 12.225c0 1.166.411 2.162 1.233 2.987l.812.814L14 22l5.955-5.974.811-.814c.823-.825 1.234-1.82 1.234-2.987s-.411-2.163-1.234-2.987z" stroke="currentColor" fill="currentColor" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </IconWrapper>
  );
}
export function IconAddToCart({ className = '', ...props }) {
  return (
    <IconWrapper id="add-to-cart" className={className} {...props}>
      <svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
          <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M5 7h3l2 9h9l3-7h-2" />
          <path d="M11 18c-1.103 0-2 .897-2 2s.897 2 2 2c1.104 0 2-.897 2-2s-.896-2-2-2m0 .9c.608 0 1.1.493 1.1 1.1 0 .608-.492 1.1-1.1 1.1-.608 0-1.1-.492-1.1-1.1 0-.607.492-1.1 1.1-1.1M18 18c-1.103 0-2 .897-2 2 0 1.101.897 1.998 2 1.998s2-.897 2-1.999S19.103 18 18 18m0 .9c.606 0 1.1.493 1.1 1.1 0 .606-.494 1.099-1.1 1.099-.608 0-1.1-.493-1.1-1.1 0-.606.492-1.1 1.1-1.1" fill="currentColor" />
          <path d="M18 9h-6M15 12V6" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IconX({ className = '', ...props }) {
  return (
    <IconWrapper id="x" className={className} {...props}>
      <svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
        <g fill="currentColor" fillRule="evenodd">
          <rect transform="rotate(45 14 14)" x="13.5" y="7" width="1" height="14" rx=".5" />
          <rect transform="rotate(-45 14 14)" x="13.5" y="7" width="1" height="14" rx=".5" />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IconPlus({ className = '', ...props }) {
  return (
    <IconWrapper id="plus" className={className} {...props}>
      <svg width="27" height="27" viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg">
        <g fill="currentColor" fillRule="evenodd">
          <rect x="13" y="6.5" width="1" height="14" rx=".5" />
          <rect transform="rotate(90 13.5 13.5)" x="13" y="6.5" width="1" height="14" rx=".5" />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IconDownload({ className = '', ...props }) {
  return (
    <IconWrapper id="download" className={className} {...props}>
      <svg width="27" height="27" viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg">
        <g stroke="currentColor" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
          <path d="M6 16v3c0 1.333.593 2 1.778 2h12.444C21.407 21 22 20.333 22 19v-3M10 12l4 4 4-4M14 6v10" />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IconUserMultiple({ className = '', ...props }) {
  return (
    <IconWrapper id="user-multiple" className={className} {...props}>
      <svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
        <g stroke="currentColor" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
          <path d="M16 20v-1.333C16 16.889 15.084 16 13.25 16h-5.5c-.759 0-1.407.26-1.945.78C5.27 17.303 5 17.93 5 18.668V20M13 10.5c0 1.667-.833 2.5-2.5 2.5S8 12.167 8 10.5 8.833 8 10.5 8s2.5.833 2.5 2.5zM23 20v-1.333C23 16.888 22.171 16 20.513 16H18M21 10.5c0 1.666-.834 2.5-2.5 2.5s-2.5-.834-2.5-2.5.834-2.5 2.5-2.5 2.5.834 2.5 2.5z" />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IconUserAdd({ className = '', ...props }) {
  return (
    <IconWrapper id="user-add" className={className} {...props}>
      <svg width="27" height="27" viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg">
        <g stroke="currentColor" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
          <path d="M17.5 21v-1.667c0-2.222-1.111-3.333-3.333-3.333H8.333c-.92 0-1.706.325-2.357.976-.65.651-.976 1.437-.976 2.357V21M14.583 9.333c0 2.223-1.11 3.334-3.333 3.334-2.222 0-3.333-1.111-3.333-3.334C7.917 7.111 9.027 6 11.25 6c2.222 0 3.333 1.111 3.333 3.333zM20 10v5M22.5 12.5h-5" />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IconUser({ className = '', ...props }) {
  return (
    <IconWrapper id="user" className={className} {...props}>
      <svg width="27" height="27" viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg">
        <g stroke="currentColor" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
          <path d="M19.5 21v-1.667c0-2.222-1.111-3.333-3.333-3.333h-5.834c-.92 0-1.706.325-2.357.976-.65.651-.976 1.437-.976 2.357V21M16.583 9.333c0 2.223-1.11 3.334-3.333 3.334-2.222 0-3.333-1.111-3.333-3.334C9.917 7.111 11.027 6 13.25 6c2.222 0 3.333 1.111 3.333 3.333z" />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IconExclude({ className = '', ...props }) {
  return (
    <IconWrapper id="exclude" className={className} {...props}>
      <svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
        <g stroke="currentColor" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 14c0 1.657-.586 3.071-1.757 4.243C17.07 19.414 15.657 20 14 20c-1.657 0-3.071-.586-4.243-1.757C8.586 17.07 8 15.657 8 14c0-1.657.586-3.071 1.757-4.243C10.93 8.586 12.343 8 14 8c1.657 0 3.071.586 4.243 1.757C19.414 10.93 20 12.343 20 14zM9.758 9.758l8.484 8.484" />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IconSearch({ className = '', ...props }) {
  return (
    <IconWrapper id="search" className={className} {...props}>
      <svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.803 17.803L23 23l-5.197-5.197C16.34 19.268 14.571 20 12.5 20c-2.071 0-3.839-.732-5.303-2.197C5.732 16.34 5 14.571 5 12.5c0-2.071.732-3.839 2.197-5.303C8.66 5.732 10.429 5 12.5 5c2.071 0 3.839.732 5.303 2.197C19.268 8.66 20 10.429 20 12.5c0 2.071-.732 3.839-2.197 5.303z" stroke="currentColor" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </IconWrapper>
  );
}
export function IconEdit({ className = '', ...props }) {
  return (
    <IconWrapper id="edit" className={className} {...props}>
      <svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
        <g stroke="currentColor" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20.5 15.5V20c0 1.028-.47 1.5-1.5 1.5H8c-.9 0-1.5-.6-1.5-1.5V9c0-.943.491-1.5 1.5-1.5h5" />
          <path d="M19 7l2.5 3-6.5 6-3.5.5.5-3.5z" />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IconTrash({ className = '', ...props }) {
  return (
    <IconWrapper id="trash" className={className} {...props}>
      <svg width="27" height="27" viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg">
        <g stroke="currentColor" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
          <path d="M6.5 9h14M19 9v10.5c0 1-.524 1.5-1.571 1.5H9.57C8.524 21 8 20.5 8 19.5V9m2.5 0V8c0-.968.505-2 1-2h4c.655 0 1 1 1 2v1" />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IconCart({ className = '', ...props }) {
  return (
    <IconWrapper id="cart" className={className} {...props}>
      <svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
          <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M5 7h3l2 9h9l3-7H12" />
          <path d="M11 18c-1.103 0-2 .897-2 2s.897 2 2 2c1.104 0 2-.897 2-2s-.896-2-2-2m0 .9c.608 0 1.1.493 1.1 1.1 0 .608-.492 1.1-1.1 1.1-.608 0-1.1-.492-1.1-1.1 0-.607.492-1.1 1.1-1.1M18 18c-1.103 0-2 .897-2 2 0 1.101.897 1.998 2 1.998s2-.897 2-1.999S19.103 18 18 18m0 .9c.606 0 1.1.493 1.1 1.1 0 .606-.494 1.099-1.1 1.099-.608 0-1.1-.493-1.1-1.1 0-.606.492-1.1 1.1-1.1" fill="currentColor" />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IconDuplicate({ className = '', ...props }) {
  return (
    <IconWrapper id="duplicate" className={className} {...props}>
      <svg width="27" height="27" viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg">
        <g transform="translate(6 6)" fill="none" fillRule="evenodd">
          <path d="M6.538 0h6.924C14.487 0 15 .513 15 1.538v6.924C15 9.487 14.487 10 13.462 10H6.538C5.513 10 5 9.487 5 8.462V1.538C5 .513 5.513 0 6.538 0z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
          <rect fill="currentColor" x="9.5" y="2.5" width="1" height="5" rx=".5" />
          <rect fill="currentColor" transform="rotate(90 10 5)" x="9.5" y="2.5" width="1" height="5" rx=".5" />
          <path d="M3 6H1.385c-.383 0-.71.135-.98.406-.27.27-.405.596-.405.979v6.23C0 14.538.462 15 1.385 15h6.23C8.538 15 9 14.538 9 13.615V12" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IconShare({ className = '', ...props }) {
  return (
    <IconWrapper id="share" className={className} {...props}>
      <svg width="27" height="27" viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg">
        <g stroke="currentColor" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
          <path d="M7 13v6.4c0 1.067.542 1.6 1.625 1.6h9.75C19.458 21 20 20.467 20 19.4V13M17 9.5L13.5 6 10 9.5M13.5 6v9" />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IconRename({ className = '', ...props }) {
  return (
    <IconWrapper id="rename" className={className} {...props}>
      <svg width="27" height="27" viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.389 7L20 10.611 10.611 20H7v-3.611z" stroke="currentColor" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </IconWrapper>
  );
}
export function IconFilter({ className = '', ...props }) {
  return (
    <IconWrapper id="filter" className={className} {...props}>
      <svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
        <path stroke="currentColor" d="M21 9H6l6 6.832v3.724L15 21v-5.168z" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </IconWrapper>
  );
}
export function IconArrowDown({ className = '', ...props }) {
  return (
    <IconWrapper id="arrow-down" className={className} {...props}>
      <svg width="27" height="27" viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg">
        <g stroke="currentColor" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
          <path d="M13.5 10.485v8M16.5 16l-3 3-3-3" />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IconAddCircle({ className = '', ...props }) {
  return (
    <IconWrapper id="add-circle" className={className} {...props}>
      <svg width="27" height="27" viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg">
        <g stroke="currentColor" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 13.5c0 2.071-.732 3.839-2.197 5.303C17.34 20.268 15.571 21 13.5 21c-2.071 0-3.839-.732-5.303-2.197C6.732 17.34 6 15.571 6 13.5c0-2.071.732-3.839 2.197-5.303C9.66 6.732 11.429 6 13.5 6c2.071 0 3.839.732 5.303 2.197C20.268 9.66 21 11.429 21 13.5zM17 13.5h-7M13.5 10v7" />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IconArrowRight({ className = '', ...props }) {
  return (
    <IconWrapper id="arroRight" className={className} {...props}>
      <svg width="27" height="27" viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg">
        <path d="M11 19.5l6-6-6-6" stroke="currentColor" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </IconWrapper>
  );
}
export function IconArrowLeft({ className = '', ...props }) {
  return (
    <IconWrapper id="arrow-left" className={className} {...props}>
      <svg width="27" height="27" viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 19.5l-6-6 6-6" stroke="currentColor" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </IconWrapper>
  );
}
export function IconMore({ className = '', ...props }) {
  return (
    <IconWrapper id="more" className={className} {...props}>
      <svg width="27" height="27" viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg">
        <g transform="translate(6 12)" fill="currentColor" fillRule="evenodd">
          <circle cx="1.5" cy="1.5" r="1.5" />
          <circle cx="7.5" cy="1.5" r="1.5" />
          <circle cx="13.5" cy="1.5" r="1.5" />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IconMusicNote({ className = '', ...props }) {
  return (
    <IconWrapper id="music-note" className={className} {...props}>
      <svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
        <g stroke="currentColor" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
          <path d="M11 17H8.5c-.872 0-1.5.598-1.5 1.5 0 .889.611 1.5 1.5 1.5h1c.889 0 1.5-.611 1.5-1.5V17zm8-1h-2.5c-.955 0-1.5.602-1.5 1.5 0 .889.611 1.5 1.5 1.5h1c.889 0 1.5-.611 1.5-1.5V16z" />
          <path d="M11 17V9.5L19 8v8" />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IconTerms({ className = '', ...props }) {
  return (
    <IconWrapper id="terms" className={className} {...props}>
      <svg width="27" height="27" viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
          <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
            <path d="M15 6H9.5c-.414 0-.768.146-1.06.44-.294.292-.44.646-.44 1.06v12c0 1 .5 1.5 1.5 1.5h9c1 0 1.5-.5 1.5-1.5V11l-5-5z" />
            <path d="M15 6v5h5" />
          </g>
          <rect fill="currentColor" x="11" y="15" width="6" height="1" rx=".5" />
          <rect fill="currentColor" x="11" y="17" width="6" height="1" rx=".5" />
          <rect fill="currentColor" x="11" y="13" width="3" height="1" rx=".5" />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IconTermsLarge({ className = '', ...props }) {
  return (
    <IconWrapper id="terms-large" className={className} {...props}>
      <svg width="36" height="36" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
        <g transform="translate(8 6)" fill="none" fillRule="evenodd">
          <path d="M2 0h9.495L20 8.5V23c0 1.105-.895 2-2 2H2c-1.105 0-2-.895-2-2V2C0 .895.895 0 2 0z" stroke="currentColor"/>
          <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M11 0v9h9"/>
          <rect fill="currentColor" x="4" y="17" width="12" height="1" rx=".5"/>
          <rect fill="currentColor" x="4" y="20" width="9" height="1" rx=".5"/>
          <rect fill="currentColor" x="4" y="14" width="12" height="1" rx=".5"/>
          <rect fill="currentColor" x="4" y="11" width="5" height="1" rx=".5"/>
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IconSettings({ className = '', ...props }) {
  return (
    <IconWrapper id="settings" className={className} {...props}>
      <svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
        <g stroke="currentColor" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
          <path d="M16 14c0 1.333-.667 2-2 2s-2-.667-2-2 .667-2 2-2 2 .667 2 2z" />
          <path d="M18.71 15.91c-.192.433-.122.819.21 1.157l.037.038c.25.249.374.55.374.9 0 .353-.125.653-.374.901-.248.25-.548.374-.9.374s-.652-.125-.9-.374l-.039-.038c-.339-.331-.725-.401-1.158-.21-.422.181-.635.502-.636.961v.108c0 .849-.425 1.273-1.273 1.273-.849 0-1.273-.424-1.273-1.273v-.057c-.011-.476-.24-.796-.687-.96-.434-.192-.82-.122-1.158.21l-.038.037c-.249.25-.55.374-.9.374-.353 0-.653-.125-.901-.374-.25-.248-.374-.548-.374-.9s.125-.652.374-.9l.038-.039c.331-.339.401-.725.21-1.158-.181-.422-.502-.635-.961-.636h-.108C7.424 15.324 7 14.899 7 14.05c0-.352.124-.652.373-.9.248-.249.548-.373.9-.373h.057c.476-.011.796-.24.96-.687.192-.434.122-.82-.21-1.158l-.037-.038c-.25-.249-.374-.55-.374-.9 0-.353.125-.653.374-.901.248-.25.548-.374.9-.374s.652.125.9.374l.039.038c.339.331.725.401 1.158.21h.05c.423-.181.635-.502.637-.961v-.108c0-.352.125-.652.373-.9.249-.249.549-.373.9-.373.848 0 1.273.424 1.273 1.273v.057c.002.46.214.78.636.96.434.192.82.122 1.158-.21l.038-.037c.249-.25.55-.374.9-.374.353 0 .653.125.901.374.25.248.374.548.374.9s-.125.652-.374.9l-.038.039c-.331.339-.401.725-.21 1.158v.05c.181.423.502.635.961.637h.108c.849 0 1.273.425 1.273 1.273 0 .848-.424 1.273-1.273 1.273h-.057c-.46.002-.78.214-.96.636z" />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IconProjectBox({ className = '', ...props }) {
  return (
    <IconWrapper id="project-box" className={className} {...props}>
      <svg width="36" height="36" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
          <path d="M.321 35.712h35.391V.322H.322z"/>
          <path d="M19.33 2.46l11.796 5.898c1.09.542 1.637 1.422 1.637 2.64V25.05c0 1.218-.546 2.098-1.637 2.64L19.33 33.59c-.88.44-1.76.44-2.64 0L4.894 27.69c-1.09-.549-1.63-1.434-1.622-2.654V10.998c0-1.218.546-2.098 1.637-2.64L16.704 2.46c.876-.435 1.75-.435 2.625 0z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
          <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M3.743 9.405l14.274 7.137 14.274-7.137M18 33.5v-17"/>
          <path d="M27.63 17.288c-.653.325-1.212.826-1.674 1.507l-.456.672-.456-.22c-.463-.222-1.022-.17-1.676.153-.653.324-1.212.825-1.675 1.506-.463.68-.693 1.34-.693 1.978 0 .637.23 1.066.693 1.289l.456.22L25.5 26l3.35-4.926.456-.672c.463-.679.694-1.338.694-1.977 0-.638-.231-1.067-.694-1.29-.462-.222-1.02-.17-1.675.153z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IconCheck({ className = '', ...props }) {
  return (
    <IconWrapper id="check" className={className} {...props}>
      <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
        <path d="M13 6l-5.5 6L5 9.273" stroke="currentColor" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </IconWrapper>
  );
}
export function IconCheckMultiple({ className = '', ...props }) {
  return (
    <IconWrapper id="check-multiple" className={className} {...props}>
      <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
        <g stroke="currentColor" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12.333 5.167l-6.389 7.666-2.555-5.11M14.889 6.444l-5.111 6.39" />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IconClear({ className = '', ...props }) {
  return (
    <IconWrapper id="clear" className={className} {...props}>
      <svg width="27" height="27" viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg">
        <g stroke="currentColor" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
          <path d="M6.5 8.3v3.9h3.9" />
          <path d="M8.131 15.45c.975 2.766 2.926 4.065 5.854 3.896 2.928-.168 4.717-1.682 5.368-4.542.651-2.86-.307-4.999-2.874-6.418-2.566-1.419-4.887-1.092-6.963.98L6.5 12.2" />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IconWarning({ className = '', ...props }) {
  return (
    <IconWrapper id="warning" className={className} {...props}>
      <svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
        <g stroke="currentColor" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12.612 7.298L5.734 19.014c-.31.55-.312 1.099-.004 1.65.307.55.771.829 1.393.836h13.754c.622-.007 1.086-.286 1.393-.836.308-.551.307-1.1-.004-1.65L15.388 7.298C15.072 6.766 14.61 6.5 14 6.5c-.61 0-1.072.266-1.388.798zM14 11.5v4M14 17.5v1" />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IconWarningLarge({ className = '', ...props }) {
  return (
    <IconWrapper id="warning-large" className={className} {...props}>
      <svg width="36" height="36" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
        <g stroke="currentcolor" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
          <path d="M16.203 10.01l-8.9 14.841c-.402.696-.404 1.392-.006 2.09.398.697.999 1.05 1.803 1.059h17.8c.804-.009 1.405-.362 1.803-1.06.398-.697.396-1.393-.006-2.089l-8.9-14.84C19.387 9.336 18.789 9 18 9c-.789 0-1.388.337-1.797 1.01zM18 15v5M18 23v1"/>
        </g>
      </svg>
    </IconWrapper>
  );
}

export function IconLock({ className = '', ...props }) {
  return (
    <IconWrapper id="lock" className={className} {...props}>
      <svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
        <g stroke="currentColor" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
          <path d="M8.929 13.643h10c.952 0 1.428.476 1.428 1.428v5c0 .953-.476 1.429-1.428 1.429h-10c-.953 0-1.429-.476-1.429-1.429v-5c0-.952.476-1.428 1.429-1.428zM10.357 13.643v-2.857c0-1.375.595-2.406 1.786-3.093 1.19-.688 2.38-.688 3.571 0 1.19.687 1.786 1.718 1.786 3.093v2.857" />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IconMail({ className = '', ...props }) {
  return (
    <IconWrapper id="mail" className={className} {...props}>
      <svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
        <g stroke="currentColor" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
          <path d="M8 8h12c.825 0 1.5.675 1.5 1.5v9c0 .825-.675 1.5-1.5 1.5H8c-.825 0-1.5-.675-1.5-1.5v-9C6.5 8.675 7.175 8 8 8z" />
          <path d="M21.5 9.5L14 14.75 6.5 9.5" />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IconExternalLink({ className = '', ...props }) {
  return (
    <IconWrapper id="external-link" className={className} {...props}>
      <svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
        <g stroke="currentColor" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
          <path d="M19.5 14.333v5c0 1.111-.556 1.667-1.667 1.667H8.667C7.556 21 7 20.444 7 19.333v-9.166c0-.46.163-.853.488-1.179.326-.325.718-.488 1.179-.488h5M17 6h5v5M12.833 15.167L22 6" />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IconSignOut({ className = '', ...props }) {
  return (
    <IconWrapper id="sign-out" className={className} {...props}>
      <svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
        <g stroke="currentColor" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
          <path d="M13 20h-3c-.65 0-1-.331-1-1V9c0-.667.22-1 1-1h3M18 16.5l2.5-2.5-2.5-2.5M20 14h-7" />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IconInCart({ className = '', ...props }) {
  return (
    <IconWrapper id="in-cart" className={className} {...props}>
      <svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
          <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M5 7h3l2 9h9l3-7h-3" />
          <path d="M11 9H9" stroke="currentColor" strokeLinecap="round" />
          <path d="M11 18c-1.103 0-2 .897-2 2s.897 2 2 2c1.104 0 2-.897 2-2s-.896-2-2-2m0 .9c.608 0 1.1.493 1.1 1.1 0 .608-.492 1.1-1.1 1.1-.608 0-1.1-.492-1.1-1.1 0-.607.492-1.1 1.1-1.1M18 18c-1.103 0-2 .897-2 2 0 1.101.897 1.998 2 1.998s2-.897 2-1.999S19.103 18 18 18m0 .9c.606 0 1.1.493 1.1 1.1 0 .606-.494 1.099-1.1 1.099-.608 0-1.1-.493-1.1-1.1 0-.606.492-1.1 1.1-1.1" fill="currentColor" />
          <path d="M15 5v8M17 11l-2 2-2-2" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IconDate({ className = '', ...props }) {
  return (
    <IconWrapper id="date" className={className} {...props}>
      <svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
        <g stroke="currentColor" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
          <path d="M7.778 7.5h12.444C21.407 7.5 22 8.056 22 9.167v11.666c0 1.111-.593 1.667-1.778 1.667H7.778C6.593 22.5 6 21.944 6 20.833V9.167C6 8.056 6.593 7.5 7.778 7.5zM17.5 5.5v4M10.5 5.5v4M6.5 12h15" />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IconList({ className = '', ...props }) {
  return (
    <IconWrapper id="list" className={className} {...props}>
      <svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
        <g transform="translate(6 10)" fill="currentColor" fillRule="evenodd">
          <rect x="4" y="8" width="12" height="1" rx=".5" />
          <rect x="4" y="4" width="12" height="1" rx=".5" />
          <rect x="4" width="12" height="1" rx=".5" />
          <rect y="8" width="2" height="1" rx=".5" />
          <rect y="4" width="2" height="1" rx=".5" />
          <rect width="2" height="1" rx=".5" />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IconPrint({ className = '', ...props }) {
  return (
    <IconWrapper id="print" className={className} {...props}>
      <svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
        <g transform="translate(6 6)" fill="none" fillRule="evenodd">
          <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M3 5V0h10v5M3 12H1.6C.533 12 0 11.481 0 10.444V6.556c0-.43.156-.797.469-1.1C.78 5.152 1.159 5 1.6 5h12.8c1.067 0 1.6.519 1.6 1.556v3.888C16 11.481 15.467 12 14.4 12H13"/>
          <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M3 9h10v7H3z"/>
          <rect fill="currentColor" x="5" y="11" width="6" height="1" rx=".5"/>
          <rect fill="currentColor" x="5" y="13" width="5" height="1" rx=".5"/>
          <rect fill="currentColor" x="2" y="6" width="2" height="1" rx=".5"/>
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IconInvoice({ className = '', ...props }) {
  return (
    <IconWrapper id="invoice" className={className} {...props}>
      <svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
        <g stroke="currentColor" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
          <path d="M8 12h12M8 17h12M13 7l-2 14M17 7l-2 14"/>
        </g>
      </svg>
    </IconWrapper>
  );
}
export function LogoAMSBeta({ className = '', ...props }) {
  return (
    <IconWrapper id="logo-ams-beta" className={className} {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" width="42.5" height="18" viewBox="0 0 42.5 18">
        <path fill="#101015" d="M18.4 15.8c-.4.4-.9.8-1.4 1-1.9.7-4-.2-4.9-2.2-1.8-4.3-1.8-4.3-3.7.1-.8 1.9-3 2.8-5 2-2-.8-3-3.1-2.1-5 .9-1.9 3-2.6 4.9-2 4 1.1 4 1.1 1.7-1.9-1.1-1.6-2.3-3.3-.4-5.6C9 .4 11.7.7 13 2.1c1.6 1.7 1.1 3.8-.3 5.6-2.4 3-2.4 3 1.3 2 .9-.3 1.7-.3 2.5-.1V5.2l-1.8-2.7c-2.2-3.4-6.6-3.4-8.8 0 0 0-3.3 5-4.7 7-2.9 4.3.1 8.5 3.6 8.5h10.9c1.5 0 3-.8 3.9-2h-.1c-.4 0-.7-.1-1.1-.2z"/>
        <path fill="#4487ff" d="M40.5 3h-21c-1.1 0-2 .9-2 2v8c0 .9.6 1.7 1.5 1.9.2 0 .3.1.5.1h21c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/>
        <path fillRule="evenodd" clipRule="evenodd" fill="#FFFFFF" d="M36.9 9.6h1.5l-.7-3h-.2l-.6 3zm1.8 1.1h-2l-.3 1.3h-1.2l1.4-6h2.1l1.4 5.9H39l-.3-1.2zM30.3 6h4.3v1.1H33V12h-1.1V7.1h-1.6V6zm-4.9 0h3.8v1.1h-2.6v1.4H29v1.1h-2.5V11h2.7v1h-3.9V6zm-3.9 2.5h.8c.2 0 .4 0 .6-.1.1-.1.2-.3.2-.5v-.1c0-.2-.1-.4-.2-.5-.1-.1-.3-.1-.6-.1h-.8v1.3zm0 2.4h.8c.2 0 .4-.1.6-.2.1-.1.2-.3.2-.5v-.1c0-.2-.1-.4-.2-.5-.1-.1-.3-.2-.6-.2h-.8v1.5zm-1.6 0h.6V7.1h-.6V6h2.6c.3 0 .5 0 .8.1l.6.3c0 .2.1.4.2.6.1.2.1.4.1.6v.1c0 .3-.1.6-.3.8-.2.2-.4.3-.7.4v.2c.3.1.5.2.7.4.2.2.3.5.3.8v.1c0 .2 0 .4-.1.6-.1.2-.2.4-.3.5-.2.1-.3.2-.6.3-.2.1-.5.2-.7.2h-2.6v-1.1z"/>
      </svg>
    </IconWrapper>
  );
}
export function IconAchievement({ className = '', ...props }) {
  return (
    <IconWrapper id="achievement" className={className} {...props}>
      <svg width="51" height="42" viewBox="0 0 51 42" xmlns="http://www.w3.org/2000/svg">
        <g stroke="#FFDE4B" strokeWidth="2" fill="none" fillRule="evenodd" strokeLinecap="round">
          <path fill="#FFDE4B" strokeLinejoin="round" d="M25.5 35.25l-9.11 4.79 1.74-10.145-7.371-7.185 10.186-1.48L25.5 12l4.555 9.23 10.186 1.48-7.37 7.185 1.74 10.145z"/>
          <path d="M25.5 4V1M47 18l2.121-2.121M4 18l-2.121-2.121"/>
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IconInfo({ className = '', ...props }) {
  return (
    <IconWrapper id="info" className={className} {...props}>
      <svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
          <path d="M23 14c0 2.485-.879 4.607-2.636 6.364C18.607 22.121 16.485 23 14 23s-4.607-.879-6.364-2.636C5.879 18.607 5 16.485 5 14s.879-4.607 2.636-6.364C9.393 5.879 11.515 5 14 5s4.607.879 6.364 2.636C22.121 9.393 23 11.515 23 14zM14 13v5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
          <circle fill="currentColor" cx="14" cy="10" r="1"/>
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IconInfoFilled({ className = '', ...props }) {
  return (
    <IconWrapper id="info-filled" className={className} {...props}>
      <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 7c0 1.933-.683 3.583-2.05 4.95C10.583 13.317 8.933 14 7 14c-1.933 0-3.583-.683-4.95-2.05C.683 10.583 0 8.933 0 7c0-1.933.683-3.583 2.05-4.95C3.417.683 5.067 0 7 0c1.933 0 3.583.683 4.95 2.05C13.317 3.417 14 5.067 14 7zM6 6v4c0 .552.448 1 1 1s1-.448 1-1V6H6zm0-3v1c0 .552.448 1 1 1s1-.448 1-1V3H6z" fill="currentColor" fillRule="evenodd"/>
      </svg>
    </IconWrapper>
  );
}
export function IconHelpFilled({ className = '', ...props }) {
  return (
    <IconWrapper id="help-filled" className={className} {...props}>
      <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 7c0 1.933-.683 3.583-2.05 4.95C10.583 13.317 8.933 14 7 14c-1.933 0-3.583-.683-4.95-2.05C.683 10.583 0 8.933 0 7c0-1.933.683-3.583 2.05-4.95C3.417.683 5.067 0 7 0c1.933 0 3.583.683 4.95 2.05C13.317 3.417 14 5.067 14 7zM6.898 3c-.85 0-1.55.207-2.098.622-.548.415-.815 1.08-.8 1.995h1.886c0-.333.071-.605.213-.814.142-.209.408-.314.799-.314.307 0 .52.071.638.213.119.142.178.302.178.479 0 .142-.048.264-.143.367-.096.103-.248.225-.455.367-.23.163-.42.315-.569.457-.15.142-.277.328-.385.559-.107.23-.16.419-.16.609 0 .254.205.46.46.46h.899c.285 0 .537-.187.62-.46.07-.229.183-.48.768-.923.276-.199.487-.397.633-.596.145-.198.218-.478.218-.84 0-.688-.25-1.224-.747-1.607C8.354 3.191 7.703 3 6.898 3zM8 9H6v1c0 .552.448 1 1 1s1-.448 1-1V9z" fill="currentColor" fillRule="evenodd"/>
      </svg>
    </IconWrapper>
  );
}
export function IconPhone({ className = '', ...props }) {
  return (
    <IconWrapper id="phone" className={className} {...props}>
      <svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
        <path d="M21 17.502v2.112c.001.397-.164.775-.457 1.043-.292.268-.683.4-1.078.365-2.166-.235-4.247-.975-6.075-2.161-1.7-1.08-3.143-2.523-4.223-4.223-1.19-1.837-1.93-3.928-2.161-6.103-.036-.394.096-.784.362-1.076C7.634 7.167 8.011 7 8.407 7h2.111c.707-.007 1.31.511 1.408 1.21.09.677.255 1.34.493 1.979.193.514.07 1.094-.317 1.485l-.894.894c1.002 1.762 2.461 3.221 4.224 4.224l.894-.894c.39-.387.97-.51 1.485-.317.638.238 1.302.403 1.978.493.708.1 1.228.714 1.21 1.428z" stroke="currentColor" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </IconWrapper>
  );
}

export function IconArrowRight2({ className = '', ...props }) {
  return (
    <IconWrapper id="arrow-right2" className={className} {...props}>
      <svg width="22" viewBox="0 0 24 7" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <title>Group</title>
        <desc>Created with Sketch.</desc>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
            <g transform="translate(-309.000000, -1334.000000)" stroke="#101015">
                <g transform="translate(309.000000, 1334.000000)">
                    <g id="Group" transform="translate(5.000000, 3.500000) rotate(-90.000000) translate(-5.000000, -3.500000) translate(2.000000, -1.000000)">
                      <line x1="3" y1="1.42108547e-14" x2="3" y2="8" id="Stroke-2" stroke="currentColor"></line>
                      <polyline points="6 5.51469318 3 8.51469318 0 5.51469318" stroke="currentColor"></polyline>
                    </g>
                </g>
            </g>
        </g>
      </svg>
    </IconWrapper>
  );
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/atoms/images/Icon/index.tsx